import type { JobItemDetails } from '../api/use-job-item-details';

export type PromptKind = 'generating' | 'archived' | 'assign-reviewer' | 'role-review' | 'publish' | null;

// Mirrors the prompt selection in JobProfileReviewPrompt so the chat idle slot
// can render an aligned affordance for the same workflow state.
export const resolvePromptKind = (item: JobItemDetails | undefined, isJobArchitect: boolean): PromptKind => {
    if (item == null) return null;
    if (item.profileGenerationInfo?.inProgress === true) return 'generating';
    if (item.isArchived) return 'archived';
    if (item.versionInfo == null || item.versionInfo.isPublished) return null;
    if (item.versionInfo.isReviewed) {
        return item.actions?.canPublish === true && isJobArchitect ? 'publish' : null;
    }
    if (item.actions?.canAssignReviewer !== true) return null;
    return item.reviewer === undefined ? 'assign-reviewer' : 'role-review';
};
